// extracted by mini-css-extract-plugin
export default {"heartWrapper":"Heart_heartWrapper__8QTOr","subHeart":"Heart_subHeart__5hhIW","floatUp":"Heart_floatUp__TAZ4O"};